import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { Dialog } from "primereact/dialog";
import styles from "./CourseInfo.module.css";
import Tiptap from "../../../components/TipTap/TipTap";
import { Card } from "primereact/card";
import { Tree } from "primereact/tree";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import {
  AddUserToWaitList,
  GetCourse,
} from "../../../store/course-store/course-actions";
import { getTokenInfo } from "../../../utils/Guard";
import { userActions } from "../../../store/auth-store/auth-slice";
import Loading from "../../../components/loading/Loading";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { classNames } from "primereact/utils";
import { CreateOrderWebinar } from "../../../store/orden-store/orden-actions";

let callOnce = true;

const CourseInfo = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const stepperRef = useRef(null);
  const userInfo = getTokenInfo();

  const [waitListModal, setWaitListModal] = useState(false);
  const [inscribeModal, setInscibeModal] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState({});
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const [startDay, setStartDay] = useState("");
  const [startMonth, setStartMonth] = useState("");
  const [startYear, setStartYear] = useState("");

  const [endDay, setEndDay] = useState("");
  const [endMonth, setEndMonth] = useState("");
  const [endYear, setEndYear] = useState("");

  const course = useSelector((state) => state.course.course);

  useEffect(() => {
    if (
      course === undefined ||
      course === null ||
      course.id === null ||
      course.id === undefined ||
      course.id === 0
    ) {
      if (
        userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== null &&
        userInfo.UserId !== undefined &&
        param.courseid !== undefined &&
        callOnce
      ) {
        callOnce = false;
        dispatch(
          GetCourse(param.courseid, userInfo.UserId, "aulaaba.aba.org.do")
        );
      } else {
        if (callOnce) {
          callOnce = false;
          dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
        }
      }
    }
  }, [course, dispatch, param.courseid, userInfo]);

  useEffect(() => {
    if (course.id !== undefined && course.id !== null) {
      setStartDay(course.startDate.split("-")[0]);
      setStartMonth(months[course.startDate.split("-")[1] - 1]);
      setStartYear(course.startDate.split("-")[2]);

      setEndDay(course.endDate.split("-")[0]);
      setEndMonth(months[course.endDate.split("-")[1] - 1]);
      setEndYear(course.endDate.split("-")[2]);
    }
  }, [course]);


  const modules =
    course && course.courseModules
      ? course.courseModules.map((module, index) => ({
          key: index + 1,
          label: module.moduleName,
          children:
            module.courseModuleLessons.map((lesson, index) => ({
              key: index + 1,
              label: lesson.name,
              url: lesson.url,
            })) || [],
        }))
      : null;

  const teachers = course.courseTeachers;

  const months = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

  const cardHeader = (img) => {
    return (
      <div className={styles.cardHeaderContainer}>
        <img alt="Card" src={img} className={styles.cardHeader} />
      </div>
    );
  };

  const formattedDays = (course?.days || "")
    .split(",")
    .map((day) => day.trim())
    .filter((day) => day);

  const cardFooter = (course) => {
    return null;
  };

  const togglerTemplate = (node, options) => {
    if (!node) {
      return;
    }
    const expanded = options.expanded;
    const iconClassName = classNames("p-tree-toggler-icon pi pi-fw", {
      "pi pi-angle-right": !expanded,
      "pi pi-angle-down": expanded,
    });

    return (
      <button
        type="button"
        className="p-tree-toggler p-link"
        tabIndex={-1}
        onClick={options.onClick}
      >
        <span className={iconClassName} aria-hidden="true"></span>
      </button>
    );
  };

  const nodeTemplate = (node, options) => {
    let label = <a style={{ fontWeight: "300" }}>{node.label}</a>;

    if (node.children) {
      label = (
        <a
          href={node.url}
          className="text-700 hover:text-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {node.key + ". " + node.label}
        </a>
      );
    }

    if (node.url) {
      label = (
        <a
          href={node.url}
          className="text-700 hover:text-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {node.label}
        </a>
      );
    }

    return <span className={options.className}>{label}</span>;
  };

  const onToggle = (event) => {
    setExpandedKeys(event.value);
  };

  const formatTextList = (text) => {
    const maxLength = 250;

    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }

    return text;
  };

  const AddToWaitList = async () => {
    await dispatch(
      AddUserToWaitList(course.id, userInfo.UserId, userInfo.Email)
    );
  };

  const InscribeInWebinar = () => {
    if (course.courseTypeId === 3) {
      dispatch(CreateOrderWebinar(course.id, userInfo.Email));

      // setInscibeModal(true);
    }
  };

  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  const startTime12 = convertTo12HourFormat(course.startTime);
  const endTime12 = convertTo12HourFormat(course.endTime);

  return (
    <>
      {(course.id === undefined || course.id <= 0) && (
        <>
          <Loading />
        </>
      )}
      {course.id > 0 && (
        <div className={styles.courseInfo}>
          <div className={styles.info}>
            <div className={styles.titleBox}>
              <h2 className={styles.courseTitle}>{course.topic}</h2>

              {course.startDate !== null &&
              course.startDate !== undefined &&
              course.endDate !== null &&
              course.endDate !== undefined &&
              course.days !== null &&
              course.days !== undefined &&
              endDay !== null &&
              endDay !== undefined &&
              course.courseTypeId !== 2 ? (
                startMonth === endMonth && startYear === endYear ? (

                  <h2 className={styles.courseDate}>
                    {`${
                      course.courseTypeId != 3 && course.courseTypeId != 4
                        ? `${startDay} al ${endDay} de ${startMonth} ${startYear}`
                        : ""
                    }
                    ${course.courseTypeId != 4 && course.courseTypeId != 6 && course.courseTypeId != 5 ? `
                    ${
                      formattedDays.length === 1
                        ? `${formattedDays[0]} |`
                        : `${formattedDays[0]} y ${formattedDays[1]} |`
                    }
                  `: ""}
      ${course.courseTypeId !== 4 && course.courseTypeId != 6 && course.courseTypeId != 5 ? `${startTime12} - ${endTime12}`: ""}`}
                  </h2>

                ) : (

                  <h2 className={styles.courseDate}>

                    {`${
                      course.courseTypeId != 3 && course.courseTypeId != 4
                        ? `${startDay} de ${startMonth} ${startYear === endYear ? "" : startYear} al ${endDay} de ${endMonth} ${endYear}`
                        : ""
                    }
     ${course.courseTypeId != 4 && course.courseTypeId != 6 && course.courseTypeId != 5 ? `
                    ${
                      formattedDays.length === 1
                        ? `| ${formattedDays[0]} |`
                        : `| ${formattedDays[0]} y ${formattedDays[1]} |`
                    }
                  `: ""}
      ${course.courseTypeId !== 4 && course.courseTypeId != 6 && course.courseTypeId != 5  ? `${startTime12} - ${endTime12}`: ""}`}
                  </h2>
                )
              ) : null}

              {course.courseTypeId != 3 ? (
                <button
                  onClick={() => (window.location.href = course.brochureUrl)}
                  className={styles.button}
                  style={{ width: "50%", fontSize: "1vw" }}
                >
                  {"Descargar el programa"}
                </button>
              ) : null}

              <div className={styles.divider}></div>
              <Tiptap description={course.description} />

              {course.videoUrl !== null &&
                course.videoUrl !== undefined &&
                course.videoUrl !== "" &&
                course.videoUrl.includes("youtube") && (
                  <>
                    <h1 className={styles.contentTitle}>{"Video"}</h1>
                    <iframe
                      width="100%"
                      height="40%"
                      src={`https://www.youtube.com/embed/${
                        course.videoUrl.split("v=")[1].split("&")[0]
                      }`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </>
                )}
              <h1 className={styles.contentTitle}>{"Contenido"}</h1>
              <Tree
                className={styles.contentTree}
                value={modules}
                nodeTemplate={nodeTemplate}
                expandedKeys={expandedKeys}
                togglerTemplate={togglerTemplate}
                onToggle={onToggle}
                // nodeKey="id"
              ></Tree>

              {course.courseTypeId !== 5 && (
                <>
          
              <h1 className={styles.contentTitle}>{"Facilitadores"}</h1>

              <div className={styles.teachersContainer}>
                {teachers.map((teacher) => (
                  <div
                    key={teacher.id}
                    className={styles.teacherCard}
                    onMouseEnter={() => {}}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <img
                        alt={teacher.name}
                        src={teacher.photoURL}
                        className={styles.teacherImg}
                      />
                    </div>
                    <div className={styles.teacherInfo}>
                      <h2 className={styles.teacherName}>
                        {teacher.name + " " + teacher.lastName}
                      </h2>
                      <p className={styles.teacherDescription}>
                        {teacher.resume !== null && teacher.resume !== undefined
                          ? formatTextList(teacher.resume)
                          : ""}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
          
                </>
              )}
            </div>
          </div>

          <Card
            title={
              course.isBought ? null : (
                <>
                  {course.courseTypeId != 3 ? course.price + "$ USD" : "Gratis"}
                </>
              )
            }
            subTitle={
              course.isBought || course.courseTypeId == 6 || course.courseTypeId == 5 || course.courseTypeId == 4 ? null : (
                <span className={styles.cardSubtitle}>
                  {""}
                  Duración: {course.duration + " hr/s"}
                </span>
              )
            }
            className={styles.cardGridItem}
            header={cardHeader(course.imageUrl)}
            footer={cardFooter(course)}
            emptyMessage="No se encontró ningún curso."
          >
            <p className={styles.cardDescription}>
              <div className="gap-3">
                {course.isBought == false && course.courseTypeId !== 3 ? (
                  <>
                    <div className="flex justify-content-center align-items-center gap-3">
                      <button
                        onClick={() => {
                          const today = new Date();

                          const splitEndDate = course.endDate.split("-");
                          const splitStartDate = course.startDate.split("-");

                          const newEndDate = new Date(
                            splitEndDate[2] +
                              "-" +
                              splitEndDate[1] +
                              "-" +
                              splitEndDate[0]
                          );

                          const newStartDate = new Date(
                            splitStartDate[2] +
                              "-" +
                              splitStartDate[1] +
                              "-" +
                              splitStartDate[0]
                          );

                          

                          (course.currentEnrollment >= course.maxEnrollment ||
                            newEndDate < today) &&
                          userInfo !== undefined &&
                          userInfo !== null
                            ? setWaitListModal(true)
                            : userInfo !== undefined && userInfo !== null
                            ? today >= newStartDate
                              ? setShowDisclaimer(true)
                              : (window.location.href =
                                  "/purchase/" + param.courseid)
                            : dispatch(userActions.setLoginVisible(true));
                        }}
                        className={styles.buyButton}
                      >
                        {course.courseTypeId != 3 ? "Comprar" : "Inscríbete"}
                      </button>
                    </div>
                    {course.courseTypeId != 3 && (
                      <span
                        className={styles.quoteButton}
                        onClick={() =>
                          (window.location.href =
                            "/contribution/" + param.courseid)
                        }
                      >
                        ¿Te interesa esta capacitación para un grupo de
                        personas? cotiza el precio aquí
                      </span>
                    )}
                  </>
                ) : course.isBought == false && course.courseTypeId === 3 ? (
                  <>
                    <div className="flex justify-content-center align-items-center gap-3">
                      <button
                        onClick={() => {
                          const today = new Date();

                          const splitEndDate = course.endDate.split("-");
                          const splitStartDate = course.startDate.split("-");

                          const newEndDate = new Date(
                            splitEndDate[2] +
                              "-" +
                              splitEndDate[1] +
                              "-" +
                              splitEndDate[0]
                          );
                          
                          const newStartDate = new Date(
                            splitStartDate[2] +
                              "-" +
                              splitStartDate[1] +
                              "-" +
                              splitStartDate[0]
                          );                                                    

                          if (userInfo === undefined || userInfo === null) {
                            dispatch(userActions.setLoginVisible(true));
                          } else if (
                            course.currentEnrollment >= course.maxEnrollment ||
                            newEndDate < today
                          ) {
                            setWaitListModal(true);
                          } else {
                            InscribeInWebinar();
                          }
                        }}
                        className={styles.buyButton}
                      >
                        Inscríbete
                      </button>
                    </div>
                    {course.courseTypeId != 3 && (
                      <span
                        className={styles.quoteButton}
                        onClick={() =>
                          (window.location.href =
                            "/contribution/" + param.courseid)
                        }
                      >
                        ¿Te interesa esta capacitación para un grupo de
                        personas? cotiza el precio aquí
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        window.location.href = "/meeting/" + param.courseid;
                      }}
                      className={styles.joinClassButton}
                    >
                     {course.courseTypeId !== 4 ? "Entrar a la clase" : "Ver en coursera"} 
                    </button>
                    <span
                      className={styles.quoteButton}
                      onClick={() =>
                        (window.location.href =
                          "/contribution/" + param.courseid)
                      }
                    >
                      ¿Te interesa esta capacitación para un grupo de personas?
                      cotiza el precio aquí
                    </span>
                  </>
                )}
              </div>
            </p>
          </Card>
          <Dialog
            modal={true}
            closable={true}
            visible={inscribeModal}
            onHide={() => setInscibeModal(false)}
          >
            <div>
              <h1 className="text-xl">
                Ya estás registrado en nuestro webinar. Pronto recibirás el
                enlace de acceso en tu correo.
              </h1>
              <Button
                label="Ok"
                onClick={() => setInscibeModal(false)}
                className={styles.button}
                style={{ width: "100%", fontSize: "1.2vw" }}
              />
            </div>
          </Dialog>
          <Dialog
            modal={true}
            closable={true}
            visible={waitListModal}
            onHide={() => setWaitListModal(false)}
          >
            <div>
              <Stepper ref={stepperRef}>
                <StepperPanel header="Lista de espera">
                  <h1 className="text-xl">
                    Este curso no está disponible, ¿Quieres ponerte en lista de
                    espera para asegurar tu cupo la próxima vez que esté activo?
                  </h1>
                  <div className="flex align-items-center justify-content-center gap-3">
                    <Button
                      label="Sí"
                      onClick={() => {
                        AddToWaitList();
                        stepperRef.current.nextCallback();
                      }}
                      className={styles.buttonYes}
                    />
                    <Button
                      label="No"
                      onClick={() => setWaitListModal(false)}
                      className={styles.buttonNo}
                    />
                  </div>
                </StepperPanel>
                <StepperPanel header="Registro exitoso">
                  <h1 className="text-xl">
                    Fuiste anotado a la lista de espera exitosamente, te
                    notificaremos vía correo electrónico cuando se vuelva a
                    impartir esta capacitación
                  </h1>
                  <Button
                    label="Ok"
                    onClick={() => setWaitListModal(false)}
                    className={styles.button}
                    style={{ width: "100%", fontSize: "1.2vw" }}
                  />
                </StepperPanel>
              </Stepper>
            </div>
          </Dialog>
          <Dialog
            modal={true}
            closable={true}
            visible={showDisclaimer}
            onHide={() => setShowDisclaimer(false)}
          >
            <div>
              <Stepper ref={stepperRef}>
                <StepperPanel header="Lista de espera">
                  <h1 className="text-xl">
                    Este curso ya comenzó, ¿Estás seguro que quieres continuar?
                  </h1>
                  <div className="flex align-items-center justify-content-center gap-3">
                    <Button
                      label="Sí"
                      onClick={() => {
                        window.location.href = "/purchase/" + param.courseid;
                      }}
                      className={styles.buttonYes}
                    />
                    <Button
                      label="No"
                      onClick={() => setWaitListModal(false)}
                      className={styles.buttonNo}
                    />
                  </div>
                </StepperPanel>
              </Stepper>
            </div>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default CourseInfo;
